import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.jsx';
import ServicesPage from './pages/Services.jsx';
import NationalitePage from './pages/Nationalite.jsx';
import RecoursOQTFPage from './pages/RecoursOQTF.jsx';
import ContactPage from './pages/Contact.jsx';
import APropos from './pages/APropos.jsx';
import Success from './pages/Success.jsx';
import Admin from './pages/Admin.jsx';
import MentionsLegales from './pages/MentionsLegales.jsx';
import Confidentialite from './pages/Confidentialite.jsx';
import Cookies from './pages/Cookies.jsx';

const AppRouter = () => {
  console.log('test')
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/titres-sejour" element={<ServicesPage />} />
        <Route path="/nationalite" element={<NationalitePage />} />
        <Route path="/recours-oqtf" element={<RecoursOQTFPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/success" element={<Success />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
